export default "__VITE_ASSET__1e6b30c3__"